import { RequiredMark } from '@apia/components';
import React from 'react';
import { Box, BoxProps } from '@apia/theme';
import { useFormContext } from '../form/FormContext';
import { useFieldSelector } from '../validationStore';
import { ValidationError } from './ValidationError';

declare global {
  interface Window {
    SHOW_REQUIRED_POSITION: string;
  }
}

export interface IWrapper extends BoxProps {
  avoidSemicolon?: boolean;
  children: React.ReactNode;
  label?: string;
  name: string;
  required?: boolean;
  type?: 'checkbox';
}

export const FieldWrapper = ({
  name,
  label,
  avoidSemicolon,
  children,
  className,
  as = 'label',
  type,
  ...props
}: IWrapper) => {
  const { name: formName } = useFormContext();
  const isRequired = useFieldSelector(
    formName,
    name,
    (global) => global?.validationRules?.required,
  );

  if (type === 'checkbox') {
    return (
      <Box
        className={`fieldWrapper checkboxWrapper ${className ?? ''}`}
        {...props}
        as={as}
      >
        {window.SHOW_REQUIRED_POSITION !== '0' && label && (
          <RequiredMark isRequired={isRequired} />
        )}
        {children}
        <span>
          {label}
          {window.SHOW_REQUIRED_POSITION === '0' && label && (
            <RequiredMark isRequired={isRequired} />
          )}
        </span>
        <ValidationError name={name} />
      </Box>
    );
  }

  /**
   * Cuando el campo no tiene etiqueta, no tiene ningún sentido mostrar marca
   * de requerido ni tag label.
   */
  if (!label) {
    return (
      <Box className={`fieldWrapper ${className ?? ''}`} as="span">
        {children}
        <ValidationError name={name} />
      </Box>
    );
  }

  return (
    <Box className={`fieldWrapper ${className ?? ''}`} {...props} as={as}>
      <Box as="span" className="fieldWrapper__label">
        {window.SHOW_REQUIRED_POSITION !== '0' && label && (
          <RequiredMark isRequired={isRequired} />
        )}
        {label}
        {!avoidSemicolon && label && <abbr className="semicolon">: </abbr>}
        {window.SHOW_REQUIRED_POSITION === '0' && label && (
          <RequiredMark isRequired={isRequired} />
        )}
      </Box>
      {children}
      <ValidationError name={name} />
    </Box>
  );
};
